import Vue from 'vue'
import api from '@/api_alv'
import { router } from '@/router.js'
import i18n from '@/assets/i18n/i18n'
import alvPlugin from '@/assets/helpers/alvPlugin'

const DIR = "az/persons"
const DEFAULT_PERSON = {
    "id": 0,
    "alvId": "ALV000000000AP",
    "picture": null,
    "pictureBig": null,
    "firstName": null,
    "lastName": null,
    "nameKatakana": null,
    "zip": null,
    "city": null,
    "state": null,
    "country": null,
    "cellphone": null,
    "email": null,
    "formOfAddress": 1,
    "formatNameAddress": null,
    "phone": null,
    "phonePrivate": null,
    "tags": null,
    "notes": null,
    "web": null,
    "facebook": null,
    "twitter": null,
    "youtube": null,
    "fax": null,
    "type": null,
    "name": null,
    "gemaName": null,
    "dealflow": null,
    "visibility": 2,
    "api": null,
    "labelcode": null,
    "language": null,
    "group": null,
    "inheritFromGroup":false,
    "addressRow1": null,
    "addressRow2": null,
    "salutation1": null,
    "salutation2": null,
    "metadata": {
        "bgNineSplit": "no",
        "customerNumber": null,
        "dateOfBirth": null,
        "currency": null,
        "gemaMember": "no",
        "freeAuthor": "no",
        "gemaNextPrefix": null,
        "gemaNextSuffix": null,
        "hkto": null,
        "ipi": null,
        "labelCompanyAlvId": null,
        "language": "de",
        "publishingCompanyAlvId": null,
        "subSplitTreshold": null,
        "ukto": null,
        "ykto": null,
        "publishingStatementsDetailsMappingId": null,
        "publishingStatementsSummaryMappingId": null,
        "publishingStatementsPerWorkMappingId": null,
        "publishingStatementsProjectsSheetsMappingId": null,
        "publishingStatementsTop10MappingId": null,
        "publishingStatementsPayeeMappingId": null,
        "labelStatementsDigitalMappingId": null,
        "labelStatementsRetailMappingId": null,
        "labelStatementsLicenseMappingId": null,
        "labelStatementsPerReleaseMappingId": null,
    },
    "finance": {
        "accountHolder": null,
        "bankName": null,
        "bankDataLocalized": null,
        "bic": null,
        "iban": null,
        "labelStatementsText": null,
        "paymentOrder": null,
        "paymentTarget": null,
        "publishingStatementsText": null,
        "recoupmentPriority": "advancesFirst",
        "registerCourt": null,
        "registrationNumber": null,
        "taxIdNumber": null,
        "taxLiabilityPercentage": null,
        "taxWithholdingPercentage": null,
        "taxWithholdingSurchargePercentage": null,
        "taxNumber": null,
        "taxOffice": null,
        "taxWaiver": null,
        "taxWaiverFrom": null,
        "taxWaiverTo": null,
        "vatId": null,
        "vatLicense": null,
        "vatRetail": null
    },
    'communications': [],
    'apiRows': []

}   

const DEFAULT_COMMUNICATION = {
    id: 0,
    commDate: null,
    commType: null,
    commNotes: null,
    recontactDate: null,
    recontactHook: null,
    status: 'no'
}

const DEFAULT_OTHER_IDS = {
    id: 0,
    value: null,
    name: null,
    personObject: null,
    type: 'recipientId',
    source: null,
    alvId: null,
    sourceAlvId: null,
    slgContractId: null,
    slgSubcatalogId: null,
}

const state = {
    // List
    azPersons: [],
    azReminders: [],
    selectedAzPersons: [],
    isAllSelectedAzPersons: false,
    expandedAzPersons: [],

    // Filters
    azPersonsSearch: "",
    selectedAzPersonsQualityFilter: [],
    selectedAzPersonsVisibilityFilter: ['visible', 'hidden'],
    
    // Sorting 
    azPersonsServerSideSortingOptions: {
        sortBy: ['name'],
        sortDesc: [false],
        mustSort: true
    },

    // Actions
    selectedAzPersonsAction: [],
    // Assign mappings all results flag
    assignAllAzPersons: false,
    // Assign mappings result link
    assignMappingsResultLink: null,
    // Assign templates (bulk)
    showAzPersonsAssignTemplatesDialog: false,
    azPersonsAssignTemplates: {
        publishingDetailsMapping: null,
        publishingSummaryMapping: null,
        publishingPerWorkMapping: null,
        publishingProjectsSheetsMapping: null,
        publishingTop10Mapping: null,
    },

    // For showConnections
    showAzPersonsShowConnectionsDialog:false,
    showConnectionsDialogText:'',
    showConnectionsCSVLink:null,

    // For reassignConnections
    showAzPersonsReassignConnectionsDialog:false,
    reassignConnectionsDialogText:'',
    reassignConnectionsCSVLink:null,

    //For Communication Form Dialog
    showAzPersonsCommunicationEditingDialog: false,

    // For Other IDs form dialog
    showAzPersonsOtherIdsEditingDialog: false,
    
    // Print A4 Labels
    printAzPersonsA4LabelsForm: {},
    printAzPersonsA4LabelsDialog: false,

    // Reassign A-Z Person
    reassignAzPersonsOptions: [],
    reassignAzPersonsDetailsdropdownAzPersons: null,

    // Import (Mapping)
    azPersonsImportTags: "",
    azPersonsImportSelectedMapping: null,

    // Details (Edit Form)
    azPersonsUniqueId: '',
    defaultNewAzPersons: DEFAULT_PERSON,
    azPersonsDetails: DEFAULT_PERSON,
    // META DATA Panel
    azPersonsMetadata: {},
    // FINANCE Panel
    azPersonsFinance: {},

    //  Comms Panel
    azPersonsCommunication: [],
    //  Selected AzPerson Communication
    selectedAzPersonsCommunication: [],
    //Communication Editing Dialog
    azPersonsCommunicationEditingDialogDetails: DEFAULT_COMMUNICATION,
    defaultAzPersonsCommunication: DEFAULT_COMMUNICATION,

    // Releases panel. Own request: GET az/persons/{alvId}/releases. Not part of the person save body.
    azPersonsReleases: [],

    // Other IDs panel
    azPersonsOtherIds: [],
    // Selected AzPerson OtherIds
    selectedAzPersonsOtherIds: [],
    // OtherIDs editing dialog
    azPersonsOtherIdsEditingDialogDetails: DEFAULT_OTHER_IDS,
    defaultAzPersonsOtherIds: DEFAULT_OTHER_IDS,
    azPersonsOtherIdsEditingDialogPersonObjectOptions: [],

    //Sync Contacts API Selection
    selectedSyncApi: [],

    //AzPerson API Rows
    azPersonsApiRows: [],

    // AI Key Name generation loading state
    azPersonsKeyNameLoading: false
}

const getters = {
    // List
    getAzPersons(state)                 { return state.azPersons },
    getAzReminders(state)                 { return state.azReminders },
    getSelectedAzPersons(state)         { return state.selectedAzPersons },
    getIsAllSelectedAzPersons(state)    { return state.isAllSelectedAzPersons },
    getExpandedAzPersons(state)         { return state.expandedAzPersons },

    // Filters
    getAzPersonsSearch(state)           { return state.azPersonsSearch },
    getSelectedAzPersonsQualityFilter(state)    {return state.selectedAzPersonsQualityFilter},
    getSelectedAzPersonsVisibilityFilter(state) {return state.selectedAzPersonsVisibilityFilter},

    //Sorting 
    getAzPersonsServerSideSortingOptions(state) {return state.azPersonsServerSideSortingOptions},

    // Actions
    getSelectedAzPersonsAction(state) { return state.selectedAzPersonsAction },
    getShowAzPersonsAssignTemplatesDialog(state) { return state.showAzPersonsAssignTemplatesDialog },
    // Assign Templates dialog values
    getAzPersonsAssignTemplates(state) { return state.azPersonsAssignTemplates },
    getAzPersonsAssignTemplatesDetailsPublishingDetailsMapping(state) { return state.azPersonsAssignTemplates.publishingDetailsMapping },
    getAzPersonsAssignTemplatesDetailsPublishingSummaryMapping(state) { return state.azPersonsAssignTemplates.publishingSummaryMapping },
    getAzPersonsAssignTemplatesDetailsPublishingPerWorkMapping(state) { return state.azPersonsAssignTemplates.publishingPerWorkMapping },
    getAzPersonsAssignTemplatesDetailsPublishingProjectsSheetsMapping(state) { return state.azPersonsAssignTemplates.publishingProjectsSheetsMapping },
    getAzPersonsAssignTemplatesDetailsPublishingTop10Mapping(state) { return state.azPersonsAssignTemplates.publishingTop10Mapping },
    getShowAzPersonsShowConnectionsDialog(state){return state.showAzPersonsShowConnectionsDialog},
    getShowConnectionsDialogText(state){return state.showConnectionsDialogText},
    getShowConnectionsCSVLink(state){return state.showConnectionsCSVLink},

    // Reassign Connections (to cleanup A-Z Persons lists of double entries)
    getShowAzPersonsReassignConnectionsDialog       (state) {return state.showAzPersonsReassignConnectionsDialog},
    getReassignConnectionsDialogText                (state) {return state.reassignConnectionsDialogText},
    getReassignConnectionsCSVLink                   (state) {return state.reassignConnectionsCSVLink},

    // Print A4 Labels
    getPrintAzPersonsA4LabelsDialog(state) { return state.printAzPersonsA4LabelsDialog },
    getPrintAzPersonsA4LabelsForm(state) { return state.printAzPersonsA4LabelsForm },
    getPrintAzPersonsA4LabelsFormDetailsNumberOfColumns(state) { return state.printAzPersonsA4LabelsForm.numberOfColumns },
    getPrintAzPersonsA4LabelsFormDetailsNumberOfRows(state) { return state.printAzPersonsA4LabelsForm.numberOfRows },
    getPrintAzPersonsA4LabelsFormDetailsLabelWidth(state) { return state.printAzPersonsA4LabelsForm.labelWidth },
    getPrintAzPersonsA4LabelsFormDetailsLabelHeight(state) { return state.printAzPersonsA4LabelsForm.labelHeight },
    getPrintAzPersonsA4LabelsFormDetailsTopMargin(state) { return state.printAzPersonsA4LabelsForm.marginTop },
    getPrintAzPersonsA4LabelsFormDetailsLeftMargin(state) { return state.printAzPersonsA4LabelsForm.marginLeft },
    getPrintAzPersonsA4LabelsFormDetailsSizeSender(state) { return state.printAzPersonsA4LabelsForm.fontSizeSender },
    getPrintAzPersonsA4LabelsFormDetailsSizeAddress(state) { return state.printAzPersonsA4LabelsForm.fontSizeAddress },
    getPrintAzPersonsA4LabelsFormDetailsSenderLine(state) { return state.printAzPersonsA4LabelsForm.senderLine },
    getPrintAzPersonsA4LabelsFormDetailsPrintTagMarking(state) { return state.printAzPersonsA4LabelsForm.tagMarking },

    // Reassign A-Z Persons
    getReassignAzPersonsOptions                     (state) { return state.reassignAzPersonsOptions },
    getReassignAzPersonsDetailsdropdownAzPersons    (state) { return state.reassignAzPersonsDetailsdropdownAzPersons },
    
    //Communication Form Dialog
    getShowAzPersonsCommunicationEditingDialog      (state) { return state.showAzPersonsCommunicationEditingDialog },
    
    // Mapping import
    getAzPersonsDetailsImportSelectedMapping(state) { return state.azPersonsImportSelectedMapping },
    getAzPersonsDetailsImportTags(state) { return state.azPersonsImportTags },
    
    // Details
    getAzPersonsUniqueId(state) { return state.azPersonsUniqueId },
    getDefaultNewAzPersons(state) { return state.defaultNewAzPersons },    
    getAzPersonsDetails(state) { return state.azPersonsDetails },
    
    // Edit form   
    getAzPersonsDetailsAlvId(state) { return state.azPersonsDetails.alvId },
    getAzPersonsDetailsGroup(state) { return state.azPersonsDetails.group },
    getAzPersonsInheritsDataFromGroup(state) { return state.azPersonsDetails.inheritFromGroup },
    getAzPersonsDetailsDepartment(state) { return state.azPersonsDetails.department },
    getAzPersonsDetailsSalutationOne(state) { return state.azPersonsDetails.salutation1 },
    getAzPersonsDetailsSalutationTwo(state) { return state.azPersonsDetails.salutation2 },
    getAzPersonsDetailsFirstName(state) { return state.azPersonsDetails.firstName },
    getAzPersonsDetailsLastName(state) { return state.azPersonsDetails.lastName },
    getAzPersonsDetailsNameKatakana(state) { return state.azPersonsDetails.nameKatakana },
    getAzPersonsDetailsAddressRowOne(state) { return state.azPersonsDetails.addressRow1 },
    getAzPersonsDetailsAddressRowTwo(state) { return state.azPersonsDetails.addressRow2 },
    getAzPersonsDetailsZip(state) { return state.azPersonsDetails.zip },
    getAzPersonsDetailsCity(state) { return state.azPersonsDetails.city },
    getAzPersonsDetailsState(state) { return state.azPersonsDetails.state },
    getAzPersonsDetailsCountry(state) { return state.azPersonsDetails.country },
    getAzPersonsDetailsCellphone(state) { return state.azPersonsDetails.cellphone },
    getAzPersonsDetailsEmail(state) { return state.azPersonsDetails.email },
    getAzPersonsDetailsPhone(state) { return state.azPersonsDetails.phone },
    getAzPersonsDetailsPhonePrivate(state) { return state.azPersonsDetails.phonePrivate },
    getAzPersonsDetailsTags(state) { return state.azPersonsDetails.tags },
    getAzPersonsDetailsNotes(state) { return state.azPersonsDetails.notes },
    getAzPersonsDetailsWeb(state) { return state.azPersonsDetails.web },
    getAzPersonsDetailsFacebook(state) { return state.azPersonsDetails.facebook },
    getAzPersonsDetailsTwitter(state) { return state.azPersonsDetails.twitter },
    getAzPersonsDetailsYoutube(state) { return state.azPersonsDetails.youtube },
    getAzPersonsDetailsFax(state) { return state.azPersonsDetails.fax },
    getAzPersonsDetailsGemaName(state) { return state.azPersonsDetails.gemaName },
    getAzPersonsDetailsDealflow(state) { return state.azPersonsDetails.dealflow },
    getAzPersonsDetailsType(state)                      { return state.azPersonsDetails.type },
    getAzPersonsDetailsApi(state)                      { return state.azPersonsDetails.api },
    getAzPersonsDetailsVisibility(state)                { return state.azPersonsDetails.visibility },
    getAzPersonsDetailsLabelcode(state)                 { return state.azPersonsDetails.labelcode },
    getAzPersonsDetailsFormOfAddress(state)             { return state.azPersonsDetails.formOfAddress },
    getAzPersonsDetailsFormatNameAddress(state)         { return state.azPersonsDetails.formatNameAddress },
    
    // Metadata Panel
    getAzPersonsMetadata(state)                         { return state.azPersonsMetadata },
    getAzPersonsMetadataDetailsLanguage(state)          { return state.azPersonsMetadata.language },
    getAzPersonsMetadataDetailsIpi(state)               { return state.azPersonsMetadata.ipi },
    getAzPersonsMetadataDetailsBirthday(state)          { return state.azPersonsMetadata.dateOfBirth },
    getAzPersonsMetadataDetailsCustomerNumber(state)    { return state.azPersonsMetadata.customerNumber },
    getAzPersonsMetadataDetailsCurrency(state)          { return state.azPersonsMetadata.currency },
    getAzPersonsMetadataDetailsGemaNextPrefix(state)    { return state.azPersonsMetadata.gemaNextPrefix },
    getAzPersonsMetadataDetailsGemaNextSuffix(state)    { return state.azPersonsMetadata.gemaNextSuffix },
    getAzPersonsMetadataDetailsSubSplitTreshold(state)  { return state.azPersonsMetadata.subSplitTreshold },
    getAzPersonsMetadataDetailsYkto(state)              { return state.azPersonsMetadata.ykto },
    getAzPersonsMetadataDetailsHkto(state)              { return state.azPersonsMetadata.hkto },
    getAzPersonsMetadataDetailsUkto(state)              { return state.azPersonsMetadata.ukto },
    getAzPersonsMetadataDetailsGemaMember(state)        { return state.azPersonsMetadata.gemaMember },
    getAzPersonsMetadataDetailsBgNineSplit(state)       { return state.azPersonsMetadata.bgNineSplit },
    getAzPersonsMetadataDetailsFreeAuthor(state)        { return state.azPersonsMetadata.freeAuthor },
    getAzPersonsMetadataDetailsLabelCompany(state)      { return state.azPersonsMetadata.labelCompanyAlvId },
    getAzPersonsMetadataDetailsPublishingCompany(state) { return state.azPersonsMetadata.publishingCompanyAlvId },
    getAzPersonsMetadataDetailsYearOfDeath(state)       { return state.azPersonsMetadata.yearOfDeath },
    getAzPersonsMetadataDetailsPublishingDetailsMapping(state) { return state.azPersonsMetadata.publishingStatementsDetailsMappingId },
    getAzPersonsMetadataDetailsPublishingSummaryMapping(state) { return state.azPersonsMetadata.publishingStatementsSummaryMappingId },
    getAzPersonsMetadataDetailsPublishingPerWorkMapping(state) { return state.azPersonsMetadata.publishingStatementsPerWorkMappingId },
    getAzPersonsMetadataDetailsPublishingProjectsSheetsMapping(state) { return state.azPersonsMetadata.publishingStatementsProjectsSheetsMappingId },
    getAzPersonsMetadataDetailsPublishingTop10Mapping   (state) { return state.azPersonsMetadata.publishingStatementsTop10MappingId },
    getAzPersonsMetadataDetailsPublishingPayeeMapping   (state) { return state.azPersonsMetadata.publishingStatementsPayeeMappingId },
    getAzPersonsMetadataDetailsLabelDigitalMapping(state){ return state.azPersonsMetadata.labelStatementsDigitalMappingId },
    getAzPersonsMetadataDetailsLabelRetailMapping(state){ return state.azPersonsMetadata.labelStatementsRetailMappingId },
    getAzPersonsMetadataDetailsLabelLicenseMapping(state){ return state.azPersonsMetadata.labelStatementsLicenseMappingId },
    getAzPersonsMetadataDetailsLabelPerReleaseMapping(state){ return state.azPersonsMetadata.labelStatementsPerReleaseMappingId },

    // Finance Panel
    getAzPersonsFinance(state) { return state.azPersonsFinance },
    getAzPersonsFinanceDetailsPaymentOrder(state) { return state.azPersonsFinance.paymentOrder },
    getAzPersonsFinanceDetailsAccountHolder(state) { return state.azPersonsFinance.accountHolder },
    getAzPersonsFinanceDetailsPaymentTarget(state) { return state.azPersonsFinance.paymentTarget },
    getAzPersonsFinanceDetailsVatId(state) { return state.azPersonsFinance.vatId },
    getAzPersonsFinanceDetailsAccountNumber(state) { return state.azPersonsFinance.accountNumber },
    getAzPersonsFinanceDetailsIban(state) { return state.azPersonsFinance.iban },
    getAzPersonsFinanceDetailsVatRetail(state) { return state.azPersonsFinance.vatRetail },
    getAzPersonsFinanceDetailsVatLicense(state) { return state.azPersonsFinance.vatLicense },
    getAzPersonsFinanceDetailsTaxOffice(state) { return state.azPersonsFinance.taxOffice },
    getAzPersonsFinanceDetailsBic(state) { return state.azPersonsFinance.bic },
    getAzPersonsFinanceDetailsRegistrationNumber(state) { return state.azPersonsFinance.registrationNumber },
    getAzPersonsFinanceDetailsTaxIdNumber(state) { return state.azPersonsFinance.taxIdNumber },
    getAzPersonsFinanceDetailsBankName(state) { return state.azPersonsFinance.bankName },
    getAzPersonsFinanceDetailsBankDataLocalized(state) { return state.azPersonsFinance.bankDataLocalized },
    getAzPersonsFinanceDetailsRegisterCourt(state) { return state.azPersonsFinance.registerCourt },
    getAzPersonsFinanceDetailsTaxNumber(state) { return state.azPersonsFinance.taxNumber },
    getAzPersonsFinanceDetailsTaxWaiver(state) { return state.azPersonsFinance.taxWaiver },
    getAzPersonsFinanceDetailsTaxWaiverFrom(state) { return state.azPersonsFinance.taxWaiverFrom },
    getAzPersonsFinanceDetailsTaxWaiverTo(state) { return state.azPersonsFinance.taxWaiverTo },
    getAzPersonsFinanceDetailsTaxLiabilityPercentage(state) { return state.azPersonsFinance.taxLiabilityPercentage },
    getAzPersonsFinanceDetailsTaxWithholdingPercentage(state) { return state.azPersonsFinance.taxWithholdingPercentage },
    getAzPersonsFinanceDetailsTaxWithholdingSurchargePercentage(state) { return state.azPersonsFinance.taxWithholdingSurchargePercentage },
    getAzPersonsFinanceDetailsRecoupmentPriority(state) { return state.azPersonsFinance.recoupmentPriority },
    getAzPersonsFinanceDetailsPublishingStatementsText(state) { return state.azPersonsFinance.publishingStatementsText },
    getAzPersonsFinanceDetailsLabelStatementsText(state) { return state.azPersonsFinance.labelStatementsText },
    
    //Communications List Panel -> Communication List Dialog
    getAzPersonsCommunication:                               (state)   => {return state.azPersonsCommunication},
    getDefaultAzPersonsCommunication:                        (state)   => {return state.defaultAzPersonsCommunication},
    getSelectedAzPersonsCommunication:                       (state)   => {return state.selectedAzPersonsCommunication},
    getAzPersonsCommunicationDetailsDate:                    (state)   => {return state.azPersonsCommunicationEditingDialogDetails.commDate },
    getAzPersonsCommunicationDetailsType:                    (state)   => {return state.azPersonsCommunicationEditingDialogDetails.commType },
    getAzPersonsCommunicationDetailsNotes:                   (state)   => {return state.azPersonsCommunicationEditingDialogDetails.commNotes },
    getAzPersonsCommunicationDetailsRecontactDate:           (state)   => {return state.azPersonsCommunicationEditingDialogDetails.recontactDate },
    getAzPersonsCommunicationDetailsStatus:                  (state)   => {return state.azPersonsCommunicationEditingDialogDetails.status },
    getAzPersonsCommunicationDetailsRecontactHook:           (state)   => {return state.azPersonsCommunicationEditingDialogDetails.recontactHook },
    getAzPersonsCommunicationEditingDialogDetails:           (state)   => {return state.azPersonsCommunicationEditingDialogDetails},

    // Other IDs panel & dialog
    getAzPersonsReleases:                                   (state) => { return state.azPersonsReleases },
    getAzPersonsOtherIds:                                   (state) => { return state.azPersonsOtherIds },
    getDefaultAzPersonsOtherIds:                            (state) => { return state.defaultAzPersonsOtherIds },
    getAzPersonsOtherIdsEditingDialogDetails:               (state) => { return state.azPersonsOtherIdsEditingDialogDetails },
    getSelectedAzPersonsOtherIds:                           (state) => { return state.selectedAzPersonsOtherIds },
    getShowAzPersonsOtherIdsEditingDialog:                  (state) => { return state.showAzPersonsOtherIdsEditingDialog },
    getAzPersonsOtherIdsPersonObjectOptions:                (state) => { return state.azPersonsOtherIdsEditingDialogPersonObjectOptions },
    getAzPersonsOtherIdsDetailsPersonObject:                (state) => { return state.azPersonsOtherIdsEditingDialogDetails.personObject },
    getAzPersonsOtherIdsDetailsName:                        (state) => { return state.azPersonsOtherIdsEditingDialogDetails.name },
    getAzPersonsOtherIdsDetailsAlvId:                       (state) => { return state.azPersonsOtherIdsEditingDialogDetails.alvId },
    getAzPersonsOtherIdsDetailsType:                        (state) => { return state.azPersonsOtherIdsEditingDialogDetails.type },
    getAzPersonsOtherIdsDetailsSource:                      (state) => { return state.azPersonsOtherIdsEditingDialogDetails.source },
    getAzPersonsOtherIdsDetailsValue:                       (state) => { return state.azPersonsOtherIdsEditingDialogDetails.value },
    getAzPersonsOtherIdsDetailsSourceAlvId:                 (state) => { return state.azPersonsOtherIdsEditingDialogDetails.sourceAlvId },
    getAzPersonsOtherIdsDetailsSlgContractId:               (state) => { return state.azPersonsOtherIdsEditingDialogDetails.slgContractId },
    getAzPersonsOtherIdsDetailsSlgSubcatalogId:             (state) => { return state.azPersonsOtherIdsEditingDialogDetails.slgSubcatalogId },
    //Sync Contacts Dialog
    getSyncAzPersonsDetailsApi(state) {return state.selectedSyncApi},

    // AzPersons API Rows
    getAzPersonsApiRows:                                     (state)   => {return state.azPersonsApiRows},
    getAzPersonsImageUrl:                                    (state)   => {return state.azPersonsDetails.picture },   
    getAzPersonsKeyNameLoading(state) { return state.azPersonsKeyNameLoading },
    getAzPersonsAssignMappingsResultLink(state) { return state.assignMappingsResultLink },
}

const mutations = { 
    
    // List
    setAzPersons: (state, personsFromDB)            => { state.azPersons = personsFromDB },
    setAzReminders: (state, remindersFromDB)            => { state.azReminders = remindersFromDB },
    setSelectedAzPersons: (state, selected)         => { state.selectedAzPersons = selected },
    setIsAllSelectedAzPersons: (state, isSelected)  => { state.isAllSelectedAzPersons = isSelected },
    setExpandedAzPersons: (state, person)           => { state.expandedAzPersons = [person] },

    // Filters
    setAzPersonsSearch: (state, search) => { state.azPersonsSearch = search },
    setSelectedAzPersonsQualityFilter: (state, value) => {state.selectedAzPersonsQualityFilter = value},
    setSelectedAzPersonsVisibilityFilter: (state, value) => {state.selectedAzPersonsVisibilityFilter = value},
    
    //Sorting
    setAzPersonsServerSideSortingOptions: (state, value) => {state.azPersonsServerSideSortingOptions = value},

    // Actions
    setSelectedAzPersonsAction: (state, selected) => { state.selectedAzPersonsAction = selected },
    setAssignAllAzPersons: (state, value) => { state.assignAllAzPersons = value },
    setAzPersonsAssignMappingsResultLink: (state, value) => { state.assignMappingsResultLink = value },
    setShowAzPersonsAssignTemplatesDialog: (state, show) => { state.showAzPersonsAssignTemplatesDialog = show },
    setAzPersonsAssignTemplates: (state, details) => { state.azPersonsAssignTemplates = details },
    setAzPersonsAssignTemplatesDetailsPublishingDetailsMapping: (state, value) => { state.azPersonsAssignTemplates.publishingDetailsMapping = value },
    setAzPersonsAssignTemplatesDetailsPublishingSummaryMapping: (state, value) => { state.azPersonsAssignTemplates.publishingSummaryMapping = value },
    setAzPersonsAssignTemplatesDetailsPublishingPerWorkMapping: (state, value) => { state.azPersonsAssignTemplates.publishingPerWorkMapping = value },
    setAzPersonsAssignTemplatesDetailsPublishingProjectsSheetsMapping: (state, value) => { state.azPersonsAssignTemplates.publishingProjectsSheetsMapping = value },
    setAzPersonsAssignTemplatesDetailsPublishingTop10Mapping: (state, value) => { state.azPersonsAssignTemplates.publishingTop10Mapping = value },

    // Show Connections
    setShowAzPersonsShowConnectionsDialog:(state,item) =>{state.showAzPersonsShowConnectionsDialog= item},
    setShowConnectionsDialogText:(state,item) =>{state.showConnectionsDialogText= item},
    setShowConnectionsCSVLink:(state,item) =>{state.showConnectionsCSVLink= item},

    // Reassign Connections
    setShowAzPersonsReassignConnectionsDialog:      (state, value)  => { state.showAzPersonsReassignConnectionsDialog = value },
    setReassignConnectionsDialogText:               (state, value)  => { state.reassignConnectionsDialogText = value },
    setReassignConnectionsCSVLink:                  (state, value)  => { state.reassignConnectionsCSVLink = value },

    // Print A4 Labels
    setPrintAzPersonsA4LabelsDialog: (state, show) => { state.printAzPersonsA4LabelsDialog = show },
    setPrintAzPersonsA4LabelsForm: (state, details) => { state.printAzPersonsA4LabelsForm = details },
    setPrintAzPersonsA4LabelsFormDetailsNumberOfColumns: (state, number) => { state.printAzPersonsA4LabelsForm.numberOfColumns = number },
    setPrintAzPersonsA4LabelsFormDetailsNumberOfRows: (state, number) => { state.printAzPersonsA4LabelsForm.numberOfRows = number },
    setPrintAzPersonsA4LabelsFormDetailsLabelWidth: (state, number) => { state.printAzPersonsA4LabelsForm.labelWidth = number },
    setPrintAzPersonsA4LabelsFormDetailsLabelHeight: (state, number) => { state.printAzPersonsA4LabelsForm.labelHeight = number },
    setPrintAzPersonsA4LabelsFormDetailsTopMargin: (state, number) => { state.printAzPersonsA4LabelsForm.marginTop = number },
    setPrintAzPersonsA4LabelsFormDetailsLeftMargin: (state, number) => { state.printAzPersonsA4LabelsForm.marginLeft = number },
    setPrintAzPersonsA4LabelsFormDetailsSizeSender: (state, number) => { state.printAzPersonsA4LabelsForm.fontSizeSender = number },
    setPrintAzPersonsA4LabelsFormDetailsSizeAddress: (state, number) => { state.printAzPersonsA4LabelsForm.fontSizeAddress = number },
    setPrintAzPersonsA4LabelsFormDetailsSenderLine: (state, text) => { state.printAzPersonsA4LabelsForm.senderLine = text },
    setPrintAzPersonsA4LabelsFormDetailsPrintTagMarking: (state, text) => { state.printAzPersonsA4LabelsForm.tagMarking = text },

    // Reassign A-Z Persons
    setReassignAzPersonsOptions:                    (state, value) => { state.reassignAzPersonsOptions = value },
    setReassignAzPersonsDetailsdropdownAzPersons:   (state, value) => { state.reassignAzPersonsDetailsdropdownAzPersons = value},

    //AzPersons Communication Dialog
    setShowAzPersonsCommunicationEditingDialog:     (state, show)  => {state.showAzPersonsCommunicationEditingDialog = show},
    
    // Mapping import
    setAzPersonsDetailsImportSelectedMapping:       (state, value) => { state.azPersonsImportSelectedMapping = value },
    setAzPersonsDetailsImportTags:                  (state, value) => { state.azPersonsImportTags = value },
    
    // Details
    setAzPersonsUniqueId:                           (state, id) => { state.azPersonsUniqueId = id },
    setDefaultNewAzPersons:                         (state) => { state.defaultNewAzPersons = DEFAULT_PERSON },
    setAzPersonsDetails:                            (state, details) => { state.azPersonsDetails = details},
    
    // Edit form
    setAzPersonsDetailsAlvId:                       (state, id) => { state.azPersonsDetails.alvId = id },
    setAzPersonsDetailsGroup:                       (state, group) => { state.azPersonsDetails.group = group },
    setAzPersonsInheritsDataFromGroup:              (state,value) =>{state.azPersonsDetails.inheritFromGroup= value},
    setAzPersonsDetailsDepartment:                  (state, department) => { state.azPersonsDetails.department = department },
    setAzPersonsDetailsSalutationOne:               (state, salutation) => { state.azPersonsDetails.salutation1 = salutation },
    setAzPersonsDetailsSalutationTwo:               (state, salutation) => { state.azPersonsDetails.salutation2 = salutation },
    setAzPersonsDetailsFirstName:                   (state, name) => { state.azPersonsDetails.firstName = name },
    setAzPersonsDetailsLastName:                    (state, name) => { state.azPersonsDetails.lastName = name },
    setAzPersonsDetailsNameKatakana:                (state, name) => { state.azPersonsDetails.nameKatakana = name },
    setAzPersonsDetailsAddressRowOne:               (state, address) => { state.azPersonsDetails.addressRow1 = address },
    setAzPersonsDetailsAddressRowTwo:               (state, address) => { state.azPersonsDetails.addressRow2 = address },
    setAzPersonsDetailsZip:                         (state, zip) => { state.azPersonsDetails.zip = zip },
    setAzPersonsDetailsCity:                        (state, city) => { state.azPersonsDetails.city = city },
    setAzPersonsDetailsState:                       (state, value) => { state.azPersonsDetails.state = value },
    setAzPersonsDetailsCountry:                     (state, country) => { state.azPersonsDetails.country = country },
    setAzPersonsDetailsCellphone:                   (state, cellphone) => { state.azPersonsDetails.cellphone = cellphone },
    setAzPersonsDetailsEmail:                       (state, email) => { state.azPersonsDetails.email = email },
    setAzPersonsDetailsPhone:                       (state, phone) => { state.azPersonsDetails.phone = phone },
    setAzPersonsDetailsPhonePrivate:                (state, phone) => { state.azPersonsDetails.phonePrivate = phone },
    setAzPersonsDetailsTags:                        (state, tags) => { state.azPersonsDetails.tags = tags },
    setAzPersonsDetailsNotes:                       (state, notes) => { state.azPersonsDetails.notes = notes },
    setAzPersonsDetailsWeb:                         (state, web) => { state.azPersonsDetails.web = web },
    setAzPersonsDetailsFacebook:                    (state, facebook) => { state.azPersonsDetails.facebook = facebook },
    setAzPersonsDetailsTwitter:                     (state, twitter) => { state.azPersonsDetails.twitter = twitter },
    setAzPersonsDetailsYoutube:                     (state, youtube) => { state.azPersonsDetails.youtube = youtube },
    setAzPersonsDetailsFax:                         (state, fax) => { state.azPersonsDetails.fax = fax },
    setAzPersonsDetailsGemaName:                    (state, gemaName) => { state.azPersonsDetails.gemaName = gemaName },
    setAzPersonsDetailsDealflow:                    (state, dealflow) => { state.azPersonsDetails.dealflow = dealflow },
    setAzPersonsDetailsType:                        (state, type) => { state.azPersonsDetails.type = type },
    setAzPersonsDetailsApi:                         (state, api) => { state.azPersonsDetails.api = api },
    setAzPersonsDetailsVisibility:                  (state, visibility) => { state.azPersonsDetails.visibility = visibility },
    setAzPersonsDetailsLabelcode:                   (state, labelcode) => { state.azPersonsDetails.labelcode = labelcode },
    setAzPersonsDetailsFormOfAddress:               (state, formOfAddress) => { state.azPersonsDetails.formOfAddress = formOfAddress },
    setAzPersonsDetailsFormatNameAddress:           (state, value) => { state.azPersonsDetails.formatNameAddress = value },
    setAzPersonsDetailsCommunications:              (state, communications) => { state.azPersonsDetails.communications = communications },

    // Metadata Panel
    setAzPersonsMetadata:                           (state, metadata) => { state.azPersonsMetadata = metadata },
    setAzPersonsMetadataDetailsLanguage:            (state, lang) => { state.azPersonsMetadata.language = lang },    
    setAzPersonsMetadataDetailsIpi:                 (state, ipi) => { state.azPersonsMetadata.ipi = ipi },
    setAzPersonsMetadataDetailsBirthday:            (state, date) => { state.azPersonsMetadata.dateOfBirth = date },
    setAzPersonsMetadataDetailsCustomerNumber:      (state, number) => { state.azPersonsMetadata.customerNumber = number },
    setAzPersonsMetadataDetailsCurrency:            (state, value) => { state.azPersonsMetadata.currency = value },
    setAzPersonsMetadataDetailsGemaNextPrefix:      (state, prefix) => { state.azPersonsMetadata.gemaNextPrefix = prefix },
    setAzPersonsMetadataDetailsGemaNextSuffix:      (state, suffix) => { state.azPersonsMetadata.gemaNextSuffix = suffix },
    setAzPersonsMetadataDetailsSubSplitTreshold:    (state, percent) => { state.azPersonsMetadata.subSplitTreshold = percent },
    setAzPersonsMetadataDetailsYkto:                (state, ykto) => { state.azPersonsMetadata.ykto = ykto },
    setAzPersonsMetadataDetailsHkto:                (state, hkto) => { state.azPersonsMetadata.hkto = hkto },
    setAzPersonsMetadataDetailsUkto:                (state, ukto) => { state.azPersonsMetadata.ukto = ukto },
    setAzPersonsMetadataDetailsGemaMember:          (state, isMember) => { state.azPersonsMetadata.gemaMember = isMember },
    setAzPersonsMetadataDetailsBgNineSplit:         (state, value) => { state.azPersonsMetadata.bgNineSplit = value },
    setAzPersonsMetadataDetailsFreeAuthor:          (state, value) => { state.azPersonsMetadata.freeAuthor = value },
    setAzPersonsMetadataDetailsLabelCompany:        (state, id) => { state.azPersonsMetadata.labelCompanyAlvId = id },
    setAzPersonsMetadataDetailsPublishingCompany:   (state, id) => { state.azPersonsMetadata.publishingCompanyAlvId = id },
    setAzPersonsMetadataDetailsYearOfDeath:         (state, year) => { state.azPersonsMetadata.yearOfDeath = year },
    setAzPersonsMetadataDetailsPublishingDetailsMapping:(state, value) => { state.azPersonsMetadata.publishingStatementsDetailsMappingId = value },
    setAzPersonsMetadataDetailsPublishingSummaryMapping:(state, value) => { state.azPersonsMetadata.publishingStatementsSummaryMappingId = value },
    setAzPersonsMetadataDetailsPublishingPerWorkMapping:(state, value) => { state.azPersonsMetadata.publishingStatementsPerWorkMappingId = value },
    setAzPersonsMetadataDetailsPublishingProjectsSheetsMapping:(state, value) => { state.azPersonsMetadata.publishingStatementsProjectsSheetsMappingId = value },
    setAzPersonsMetadataDetailsPublishingTop10Mapping:(state, value) => { state.azPersonsMetadata.publishingStatementsTop10MappingId = value },
    setAzPersonsMetadataDetailsPublishingPayeeMapping:(state, value) => { state.azPersonsMetadata.publishingStatementsPayeeMappingId = value },
    setAzPersonsMetadataDetailsLabelDigitalMapping: (state, value) => { state.azPersonsMetadata.labelStatementsDigitalMappingId = value },
    setAzPersonsMetadataDetailsLabelRetailMapping: (state, value) => { state.azPersonsMetadata.labelStatementsRetailMappingId = value },
    setAzPersonsMetadataDetailsLabelLicenseMapping: (state, value) => { state.azPersonsMetadata.labelStatementsLicenseMappingId = value },
    setAzPersonsMetadataDetailsLabelPerReleaseMapping: (state, value) => { state.azPersonsMetadata.labelStatementsPerReleaseMappingId = value },

    // Finance Panel
    setAzPersonsFinance: (state, finance) => { state.azPersonsFinance = finance },
    setAzPersonsFinanceDetailsPaymentOrder: (state, text) => { state.azPersonsFinance.paymentOrder = text },
    setAzPersonsFinanceDetailsAccountHolder: (state, name) => { state.azPersonsFinance.accountHolder = name },
    setAzPersonsFinanceDetailsPaymentTarget: (state, days) => { state.azPersonsFinance.paymentTarget = days },
    setAzPersonsFinanceDetailsVatId: (state, id) => { state.azPersonsFinance.vatId = id },
    setAzPersonsFinanceDetailsIban: (state, iban) => { state.azPersonsFinance.iban = iban },
    setAzPersonsFinanceDetailsVatRetail: (state, retail) => { state.azPersonsFinance.vatRetail = retail },
    setAzPersonsFinanceDetailsVatLicense: (state, license) => { state.azPersonsFinance.vatLicense = license },
    setAzPersonsFinanceDetailsTaxOffice: (state, office) => { state.azPersonsFinance.taxOffice = office },
    setAzPersonsFinanceDetailsBic: (state, bic) => { state.azPersonsFinance.bic = bic },
    setAzPersonsFinanceDetailsRegistrationNumber: (state, number) => { state.azPersonsFinance.registrationNumber = number },
    setAzPersonsFinanceDetailsTaxIdNumber: (state, number) => { state.azPersonsFinance.taxIdNumber = number },
    setAzPersonsFinanceDetailsBankName: (state, name) => { state.azPersonsFinance.bankName = name },
    setAzPersonsFinanceDetailsBankDataLocalized: (state, value) => { state.azPersonsFinance.bankDataLocalized = value },
    setAzPersonsFinanceDetailsRegisterCourt: (state, name) => { state.azPersonsFinance.registerCourt = name },
    setAzPersonsFinanceDetailsTaxNumber: (state, number) => { state.azPersonsFinance.taxNumber = number },
    setAzPersonsFinanceDetailsTaxWaiver: (state, selected) => { state.azPersonsFinance.taxWaiver = selected },
    setAzPersonsFinanceDetailsTaxWaiverFrom: (state, date) => { state.azPersonsFinance.taxWaiverFrom = date },
    setAzPersonsFinanceDetailsTaxWaiverTo: (state, date) => { state.azPersonsFinance.taxWaiverTo = date },
    setAzPersonsFinanceDetailsTaxLiabilityPercentage: (state, percentage) => { state.azPersonsFinance.taxLiabilityPercentage = percentage },
    setAzPersonsFinanceDetailsTaxWithholdingPercentage: (state, percentage) => { state.azPersonsFinance.taxWithholdingPercentage = percentage },
    setAzPersonsFinanceDetailsTaxWithholdingSurchargePercentage: (state, percentage) => { state.azPersonsFinance.taxWithholdingSurchargePercentage = percentage },
    setAzPersonsFinanceDetailsRecoupmentPriority: (state, value) => { state.azPersonsFinance.recoupmentPriority = value },
    setAzPersonsFinanceDetailsPublishingStatementsText: (state, text) => { state.azPersonsFinance.publishingStatementsText = text },
    setAzPersonsFinanceDetailsLabelStatementsText: (state, text) => { state.azPersonsFinance.labelStatementsText = text },
    
    //Communication Panel -> Communication Form Dialog
    setAzPersonsCommunication:                               (state,comms)     => {state.azPersonsCommunication = comms}, 
    setAzPersonsCommunicationEditingDialogDetails:           (state, details)  => {state.azPersonsCommunicationEditingDialogDetails = details},
    setSelectedAzPersonsCommunication:                       (state, selected) => {state.selectedAzPersonsCommunication = selected},
    setAzPersonsCommunicationDetailsDate:                    (state, date)     => {state.azPersonsCommunicationEditingDialogDetails.commDate = date},
    setAzPersonsCommunicationDetailsType:                    (state, type)     => {state.azPersonsCommunicationEditingDialogDetails.commType = type},
    setAzPersonsCommunicationDetailsNotes:                   (state, note)     => {state.azPersonsCommunicationEditingDialogDetails.commNotes = note},
    setAzPersonsCommunicationDetailsRecontactDate:           (state, date)     => {state.azPersonsCommunicationEditingDialogDetails.recontactDate = date},
    setAzPersonsCommunicationDetailsStatus:                  (state, status)   => {state.azPersonsCommunicationEditingDialogDetails.status = status},
    setAzPersonsCommunicationDetailsRecontactHook:           (state, hook)     => {state.azPersonsCommunicationEditingDialogDetails.recontactHook = hook},

    // Other IDs panel & dialog
    setAzPersonsReleases:                                   (state, value)  => { state.azPersonsReleases = value },
    setAzPersonsOtherIds:                                   (state, value)  => { state.azPersonsOtherIds = value },
    setAzPersonsOtherIdsEditingDialogDetails:               (state, value)  => { state.azPersonsOtherIdsEditingDialogDetails = value },
    setSelectedAzPersonsOtherIds:                           (state, value)  => { state.selectedAzPersonsOtherIds = value },
    setShowAzPersonsOtherIdsEditingDialog:                  (state, value)  => { state.showAzPersonsOtherIdsEditingDialog = value },
    setAzPersonsOtherIdsPersonObjectOptions:                (state, value)  => { state.azPersonsOtherIdsEditingDialogPersonObjectOptions = value },
    setAzPersonsOtherIdsDetailsPersonObject:                (state, value)  => { state.azPersonsOtherIdsEditingDialogDetails.personObject = value },
    setAzPersonsOtherIdsDetailsName:                        (state, value)  => { state.azPersonsOtherIdsEditingDialogDetails.name = value },
    setAzPersonsOtherIdsDetailsAlvId:                       (state, value)  => { state.azPersonsOtherIdsEditingDialogDetails.alvId = value },
    setAzPersonsOtherIdsDetailsType:                        (state, value)  => { state.azPersonsOtherIdsEditingDialogDetails.type = value },
    setAzPersonsOtherIdsDetailsSource:                      (state, value)  => { state.azPersonsOtherIdsEditingDialogDetails.source = value },
    setAzPersonsOtherIdsDetailsValue:                       (state, value)  => { state.azPersonsOtherIdsEditingDialogDetails.value = value },
    setAzPersonsOtherIdsDetailsSourceAlvId:                 (state, value)  => { state.azPersonsOtherIdsEditingDialogDetails.sourceAlvId = value },
    setAzPersonsOtherIdsDetailsSlgContractId:               (state, value)  => { state.azPersonsOtherIdsEditingDialogDetails.slgContractId = value },
    setAzPersonsOtherIdsDetailsSlgSubcatalogId:             (state, value)  => { state.azPersonsOtherIdsEditingDialogDetails.slgSubcatalogId = value },

    //Sync Contacts Dialog
    setSyncAzPersonsDetailsApi:                             (state, api) => { state.selectedSyncApi = api},
    
    // AzPersons API Rows
    setAzPersonsApiRows:                                     (state, value)   => {state.azPersonsApiRows = value},
    //ImageUploader
    setAzPersonsImageUrl:                                    (state, item)   => { state.azPersonsDetails.picture = item },

    // AI loading
    setAzPersonsKeyNameLoading:                              (state, value)  => { state.azPersonsKeyNameLoading = value },

}  

const actions = {
// FETCH AZ PERSONS
    async fetchAzPersons( { commit, getters }) {
        commit('setIsLoading', true)
        
        // check for set filters
        let filterObj = {
            search : getters.getAzPersonsSearch,
            quality: getters.getSelectedAzPersonsQualityFilter,
            visibility: getters.getSelectedAzPersonsVisibilityFilter,
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // sorting options
        let options = getters.getAzPersonsServerSideSortingOptions;

        // Get list items from db
        let response = await api.getListData2(DIR, getters.getCurrentPage, options.sortBy, options.sortDesc, paramsString)   
        
        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setAzPersons', [])
        } else {
            commit('setAzPersons', response.list)
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },
    
    // FETCH REMINDER LIST
    async fetchAZReminders( { commit }) {  
        let reminders = await api.getReminders(DIR, 'reminder')
        commit('setAzReminders',reminders)
    },

    // Generate KEY NAME (romaji) from first/last names via backend AI
    async fetchAzPersonsKeyNameFromAi({ commit }, { firstName, lastName }) {
        commit('setAzPersonsKeyNameLoading', true)
        try {
            const res = await api.getAzPersonsKeyNameTransliteration(firstName, lastName)
            if (res && res.error === 1) {
                commit('setAzPersonsKeyNameLoading', false)
                const errorMsg = res.response && res.response.errorMsg ? res.response.errorMsg : 'Validation error'
                return { error: true, errorMsg: errorMsg }
            }
            if (res && res.error === -1 && res.response && res.response.keyName) {
                commit('setAzPersonsKeyNameLoading', false)
                return { formattedKeyName: res.response.keyName }
            }
        } catch (e) {
            // silent
        } finally {
            commit('setAzPersonsKeyNameLoading', false)
        }
        return { formattedKeyName: null }
    },

    // FETCH DETAILS
    async fetchAzPersonsDetails({ commit, getters, dispatch }, alvId) {
        let values
        // List expand only. Edit form uses the same details fetch and does not need this panel.
        let releasesPromise = null
        if (alvId !== 'new' && router.currentRoute.name === 'AzPersons') {
            releasesPromise = dispatch('fetchAzPersonsReleases', alvId)
        } else {
            commit('setAzPersonsReleases', [])
        }

        if(alvId === 'new') {
            let defaultValues = JSON.parse(JSON.stringify(getters.getDefaultNewAzPersons)) 
            // let country = this._vm.$alvPlugin.setCountryInAzGroupsAndPersons()
            // As we only support two languages for A-Z we have to check the account language,
            // to find out if we will set 'de' or 'en' as A-Z language.
            let accountLanguage = getters.getUserLanguage
            defaultValues.metadata.language = accountLanguage === 'de' ? accountLanguage : 'en'
            // Country is not a required field anymore
            // defaultValues.country = country
            
            values = defaultValues
        }
        else {
            let response = await api.getDetailsById(DIR, alvId)
            if(response === undefined || response.length === 0 || response.error === 1) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: 'Daten konnten nicht oder nur unvollständig geladen werden'
                })
            } else values = response
        }
        
        // Read-only subresource. Drop it if the details payload still carries it, so save does not post it back.
        if (values) delete values.releases

        commit('setAzPersonsDetails', values)
        dispatch('fetchAzPersonsMetadata')
        dispatch('fetchAzPersonsFinance')
        dispatch('fetchAzPersonsCommunications')
        dispatch('fetchAzPersonsOtherIds')
        dispatch('fetchAzPersonsApiRows')
        if (releasesPromise) await releasesPromise
        commit('setIsLoading', false)
    },

    // GET az/persons/{alvId}/releases — list envelope { list: [...] }, same row shape as label releases.
    async fetchAzPersonsReleases({ commit }, alvId) {
        if (!alvId || alvId === 'new') {
            commit('setAzPersonsReleases', [])
            return
        }

        let response = await api.getDetailsById(DIR, alvId, '/releases')
        let releases = []
        if (response && response.error !== 1) {
            if (Array.isArray(response.list)) releases = response.list
            else if (Array.isArray(response)) releases = response
        }
        commit('setAzPersonsReleases', releases)
    },

    // FETCH METADATA
    async fetchAzPersonsMetadata({ getters, commit }) {
        let metadataFromDB = getters.getAzPersonsDetails.metadata
        commit('setAzPersonsMetadata', metadataFromDB)
    },

    // FETCH FINANCE
    async fetchAzPersonsFinance({ getters, commit }) {
        let financeFromDB = getters.getAzPersonsDetails.finance

        if(financeFromDB){
            if(financeFromDB.vatLicense !== null && financeFromDB.vatLicense !== ''){
                financeFromDB.vatLicense = i18n.n(financeFromDB.vatLicense,'number')
            }
            if(financeFromDB.vatRetail !== null && financeFromDB.vatRetail !== ''){
                financeFromDB.vatRetail = i18n.n(financeFromDB.vatRetail,'number')
            }
        }
        commit('setAzPersonsFinance', financeFromDB)
    },
    // FETCH PERSON COMMUNICATIONS LIST
    async fetchAzPersonsCommunications({commit, getters}){
        let communicationsFromDB = getters.getAzPersonsDetails.communications

        if(communicationsFromDB == undefined || communicationsFromDB == null){
            communicationsFromDB = [];
        }

        commit('setAzPersonsCommunication', communicationsFromDB)
    },
    // FETCH OTHER IDs LIST
    async fetchAzPersonsOtherIds({commit, getters}) {
        let otherIdsFromDb = getters.getAzPersonsDetails.otherIds

        if (otherIdsFromDb == undefined || otherIdsFromDb == null) {
            otherIdsFromDb = []
        }

        for (let i = 0; i < otherIdsFromDb.length; i++) {
            let obj = otherIdsFromDb[i];
            // obj.personObject = {
            //     gemaName: obj.name,
            //     alvId: obj.alvId,
            //     firstName: null,
            //     lastName: null,
            //     typeOfAz: null,
            //     ipi: null
            // }
            // if (obj.name == null) {
            //     obj.name = getters.getAzPersonsDetailsGemaName
            // }
        }

        commit('setAzPersonsOtherIds', otherIdsFromDb)
    },
    // FETCH AZ entries for OTHER IDs (Abrechnungsquelle): one row per A-Z entry (ALVCODE-1537)
    async fetchAutocompleteAzPersonsOtherIdsPersonObject({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setAzPersonsOtherIdsPersonObjectOptions', response.list)
    },

    // FETCH PERSON API ROWS
    async fetchAzPersonsApiRows({commit, getters}){
        let apiRowsFromDB = getters.getAzPersonsDetails.apiRows

        if(apiRowsFromDB == undefined || apiRowsFromDB == null){
            apiRowsFromDB = [];
        }

        commit('setAzPersonsApiRows', apiRowsFromDB)
    },
    
    // SAVE
    async saveAzPersonsForm({ commit, getters, dispatch }, redirect = true) { // redirect attribute is used when the saving function is called from another page than AzPersonsEdit
        let alvId = getters.getAzPersonsDetailsAlvId
        let azPersonsDetails = { ...getters.getAzPersonsDetails } // clone instead of modifying store directly (below)
        let metaData = azPersonsDetails.metadata // not that there is no camel case
        let isNew = false
        
        if(!redirect) { isNew = getters.getAzPersonsDetails['id'] === 0 }
        else isNew = router.currentRoute.params.alvId == "new"

        // Instead of sending empty array, send null for currency
        if ((Array.isArray(metaData.currency) && metaData.currency.length === 0) || metaData.currency == "array") {
            azPersonsDetails.metadata.currency = null;
        }

        let response = await api.saveEditForm(DIR, alvId, azPersonsDetails, isNew)   

        if(response === undefined || response.length === 0 || response.error === 1) { 
            let errorMessages = response.response.errorMsg
            let errorMessageForSnackbar = i18n.t('lang_GENERIC_SNACKBAR_SAVING_NOT_SUCCESSFUL')
            errorMessages.forEach(msg => {
                errorMessageForSnackbar += '<br />' + i18n.t(msg)
            })

            commit('setSnackbar', {
                type: 'error',
                msg: errorMessageForSnackbar
            })
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_AZ_PERSONS_SNACKBAR_PERSON_SAVED')
            })

            // redirect for url now with ALVID
            if(isNew && redirect) router.push( { name: 'AzPersonsEdit', params: { alvId: response.response.alvId }} )

            // refresh data
            await dispatch('fetchAzPersonsDetails', response.response.alvId)
            this._vm.$alvPlugin.updateListOfDistributorsInLocalStorageAccordingToEntity(getters.getAzPersonsDetails)
        }
    },
// ACTIONS Switch
    async doAzPersonsAction({ dispatch, commit }) {
        if(state.selectedAzPersonsAction === 'assignTemplates') {
            if(state.selectedAzPersons.length === 0){
                let r = await dispatch('runConfirmationDialog')
                if (r) {
                    commit('setAssignAllAzPersons', true)
                    commit('setShowAzPersonsAssignTemplatesDialog', true)
                }
            } else {
                commit('setAssignAllAzPersons', false)
                commit('setShowAzPersonsAssignTemplatesDialog', true)
            }
        }
        else if(state.selectedAzPersonsAction === "showConnections" || state.selectedAzPersonsAction === "convertToGroup"){ 
            if(state.selectedAzPersons.length === 0 || state.selectedAzPersons.length > 1){
                commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                commit('setShowSelectionRequiredDialog', true)
            } else {
                switch(state.selectedAzPersonsAction) {
                    case 'showConnections':
                        dispatch('showConnections') 
                        break
                    case 'convertToGroup':
                        dispatch('convertToGroup') 
                        break
                }

            }
        } else if(state.selectedAzPersons.length > 0) {
            if(state.selectedAzPersonsAction === "reassignConnections" && state.selectedAzPersons.length < 2){
                commit('setSelectionRequiredText', 'lang_GENERIC_CAPTION_SELECTION_REQUIRED_AT_LEAST_TWO') 
                commit('setShowSelectionRequiredDialog', true)
            } else {
                switch(state.selectedAzPersonsAction) {
                    case 'printAzPersonsA4Labels':
                        dispatch('fetchPrintA4LabelsDialogData')
                        break
                    case 'printAzPersonsA6Labels':
                        dispatch('createA6PDF')
                        break
                    case 'reassignConnections':
                        dispatch('reassignConnections')
                        break
                    case 'delete':
                        commit('setShowDeletionDialog', true)
                        break
                    case 'replaceTags':
                        commit('setShowManageTagsDialog', true)
                        break
                    case 'syncData':
                        commit('setShowSyncDataDialog', true)
                        break
                }
            }
        } else {
            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
            commit('setShowSelectionRequiredDialog', true)
        }
    },

    // Assign mappings (frontend -> backend)
    async assignMappingsAzPersons({ getters, commit, state }, params = {}) {
        const DIR = 'az/persons'
        const queryParams = { action: 'assignMappings' }

        const details = getters.getAzPersonsAssignTemplates
        const mappings = {
            publishing_statements: {
                summary: getters.getAzPersonsAssignTemplatesDetailsPublishingSummaryMapping || null,
                details: getters.getAzPersonsAssignTemplatesDetailsPublishingDetailsMapping || null,
                perWork: getters.getAzPersonsAssignTemplatesDetailsPublishingPerWorkMapping || null,
                projectsSheets: getters.getAzPersonsAssignTemplatesDetailsPublishingProjectsSheetsMapping || null,
                top10: getters.getAzPersonsAssignTemplatesDetailsPublishingTop10Mapping || null,
            }
        }

        const metaData = { mappings }
        if (params && params.clearEmpty === true) {
            metaData.clearEmpty = true
        }
        if (state.assignAllAzPersons === false) {
            metaData['alvIds'] = getters.getSelectedAzPersons
        }

        const response = await api.triggerAction(DIR, metaData, queryParams)
        commit('setAssignAllAzPersons', false)

        if (response && response.error === -1 && response.response && response.response.path) {
            commit('setAzPersonsAssignMappingsResultLink', response.response.path)
            // keep dialog open and show cloud icon
        } else if (response && response.response && response.response.errorMsg) {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg)
            })
        }
    },


    
    // Fetch values for print A4 Labels
    async fetchPrintA4LabelsDialogData({ commit }) {
        let response = await api.getSpecificFormData(DIR + '/a4PrintValues')

        if(response.error === -1) {
            commit('setPrintAzPersonsA4LabelsForm', response.response)
            commit('setPrintAzPersonsA4LabelsDialog', true)
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: 'Es ist ein Fehler aufgetreten' // TODO: lang const from BE or FE?!
            })
        }
    },

    // A4
    async createAddressLabelsPDF({ getters, commit }) {
        let queryParams = { "action": "printA4" }

        let metaData = {
            "azIds"             : getters.getSelectedAzPersons ,
            "numberOfColumns"   : getters.getPrintAzPersonsA4LabelsFormDetailsNumberOfColumns,
            "numberOfRows"      : getters.getPrintAzPersonsA4LabelsFormDetailsNumberOfRows,
            "labelWidth"        : getters.getPrintAzPersonsA4LabelsFormDetailsLabelWidth,
            "labelHeight"       : getters.getPrintAzPersonsA4LabelsFormDetailsLabelHeight,
            "marginTop"         : getters.getPrintAzPersonsA4LabelsFormDetailsTopMargin,
            "marginLeft"        : getters.getPrintAzPersonsA4LabelsFormDetailsLeftMargin,
            "tagMarking"        : getters.getPrintAzPersonsA4LabelsFormDetailsPrintTagMarking,
            "senderLine"        : getters.getPrintAzPersonsA4LabelsFormDetailsSenderLine,
            "fontSizeSender"    : getters.getPrintAzPersonsA4LabelsFormDetailsSizeSender,
            "fontSizeAddress"   : getters.getPrintAzPersonsA4LabelsFormDetailsSizeAddress
        }
        
        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            if(response.response.path !== null) {
                api.getFileFromALV(response.response.path)
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
                })
            }
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    // A6
    async createA6PDF({ getters, commit }) {
        let queryParams = { "action": "printA6" }

        let metaData = {
            "alvIds"            : getters.getSelectedAzPersons ,
            "sendingCompany"    : getters.getSelectedLabelCompanyId
        }
        
        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            if(response.response.path !== null) {
                api.getFileFromALV(response.response.path)
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
                })
            }
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    // Show connections
    async showConnections({ getters, commit }) {
        let queryParams = { "action": "showConnections" }

        let metaData = {
            "alvIds"            : getters.getSelectedAzPersons ,
            
        }
        
        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            const path = response.response.path;
            if(path === null) {
                commit('setShowConnectionsDialogText','lang_AZ_PERSONS_SHOW_CONNECTIONS_NO_CONNECTIONS')
            } else if(path !== null){
                commit('setShowConnectionsDialogText','lang_AZ_PERSONS_SHOW_CONNECTIONS_CSV_FILE')
                commit('setShowConnectionsCSVLink',path)
            }
            commit('setShowAzPersonsShowConnectionsDialog',true)
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    // Reassign Connections
    async reassignConnections({ getters, commit }) {
        let queryParams = { "action": "showConnections" }
        let metaData = {
            "alvIds"            : getters.getSelectedAzPersons,
        }
        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response.error === -1) {
            const path = response.response.path;
            if(path === null) {
                commit('setReassignConnectionsDialogText','lang_AZ_MESSAGE_REASSIGN_CONNECTIONS_NO_CONNECTIONS')
            } else if(path !== null){
                commit('setReassignConnectionsDialogText','lang_AZ_MESSAGE_REASSIGN_CONNECTIONS_CSV_FILE')
                commit('setReassignConnectionsCSVLink', path)
            }
            commit('setShowAzPersonsReassignConnectionsDialog',true)
        } else {
            // no connections to reassign
            commit('setSnackbar', {
                type: 'error',
                msg: 'lang_AZ_PERSONS_REASSIGN_CONNECTIONS_NO_CONNECTIONS'
            })
        }
    },

    // Launch Reassign Connections
    async reassignConnectionsOfSelected({ getters, commit, dispatch }) {
        let queryParams = { "action": "reassignConnectionsOfSelected" }
        let metaData = {
            "alvIds"    : getters.getSelectedAzPersons,
            "selected"  : getters.getReassignAzPersonsDetailsdropdownAzPersons.value
        }
        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_AZ_MESSAGE_SUCCESS_REASSIGN_CONNECTIONS')
            })
            dispatch('fetchAzPersons')
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_AZ_MESSAGE_ERROR_REASSIGN_CONNECTIONS')
            })
        }
        commit('setSelectedAzPersons', [])
        commit('setSelectedAzPersonsAction', [])
        commit('setIsAllSelectedAzPersons', false)
    },
    
    // Convert A-Z Person to Group
    async convertToGroup({ getters, commit }) {
        let queryParams = { "action": "convertToGroup" }

        let metaData = {
            "alvIds"            : getters.getSelectedAzPersons ,
        }
        
        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            for(let i = 0; i < getters.getSelectedAzPersons.length; i++) {
                let index = getters.getAzPersons.findIndex(person => person.alvId == getters.getSelectedAzPersons[i])
                Vue.delete(getters.getAzPersons, index)
            }

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_AZ_PERSONS_MESSAGE_SUCCESS_ENTRY_CONVERTED')
            })
            
            dispatch('fetchAzPersons')
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_AZ_PERSONS_MESSAGE_ERROR_CONVERSION_FAILED')
            })
        }

        commit('setSelectedAzPersons', [])
        commit('setSelectedAzPersonsAction', [])
        commit('setIsAllSelectedAzPersons', false)
    },

    // DELETE
    async deleteSelectedAzPersons({ commit, getters, dispatch }) {
        let response = await api.deleteEntries(DIR, getters.getSelectedAzPersons)

        if(response.error === -1) {
            for(let i = 0; i < getters.getSelectedAzPersons.length; i++) {
                let index = getters.getAzPersons.findIndex(person => person.alvId == getters.getSelectedAzPersons[i])
                Vue.delete(getters.getAzPersons, index)
            }

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })
            
            dispatch('fetchAzPersons')
        } else {
            commit('setErrorDialogCsvLink', response.response.path)
            commit('setErrorMessageCode', response.errorCode)
            commit('setShowErrorDialog', true)
        }

        commit('setSelectedAzPersons', [])
        commit('setSelectedAzPersonsAction', [])
        commit('setIsAllSelectedAzPersons', false)
    },
    //DELETE AzPersons Communication 
    async deleteSelectedAzPersonsCommunication({commit, getters, dispatch}){

        let response = await api.deleteEntries(DIR + '?deleteComm', getters.getSelectedAzPersonsCommunication)
        
        if(response.error === -1){
            let index = getters.getAzPersonsCommunication.findIndex(comm => comm.id == getters.getSelectedAzPersonsCommunication.id)
            Vue.delete(getters.getAzPersonsCommunication, index)
            
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })

        }
        
        commit('setSelectedAzPersonsCommunication', [])
    },
    // DELETE OTHER IDs
    deleteSelectedAzPersonsOtherIds({commit, getters}) {
        let id = getters.getSelectedAzPersonsOtherIds
        let index = state.azPersonsOtherIds.findIndex(cond => cond.id == id)

        let startOtherIdsAmount = getters.getAzPersonsOtherIds.length
        Vue.delete(state.azPersonsOtherIds, index)
        let newOtherIdsAmount = getters.getAzPersonsOtherIds.length
        commit("setSelectedAzPersonsOtherIds", [])

        if(startOtherIdsAmount > newOtherIdsAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        }

        if(newOtherIdsAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },
    // EXPORT
    async exportAzPersons({ commit, getters, dispatch }) {
        
        let queryParams = {
            "action" : "export",
        }

        let response = await api.triggerAction(DIR, {}, queryParams)
        if(response.error === 1) {  
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            } 
        } else {
            api.getFileFromALV(response.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        }
    }
}

export default {
    state, getters, actions, mutations
}
